import { useEffect, useState } from "react"
import "react-dates/initialize"
import Select from "react-select"
import ExcelUploader from "components/Shared/ExcelUploader/ExcelUploader"
import Button from "components/Shared/Button/Button"
import useCommon from "hooks/useCommon"
import AlertComponent from "components/Shared/Common/Alert"
import { Loading } from "@wfp/ui"
import { useDeleteSurveyRPMEMutation, useSaveRpmeBasketRPMEMutation } from "../../services/rpme/survey"

interface Props {
  surveyTypeId: number
  surveyId: number
  onSave?: () => void
}

const priceOptions = [
  { label: "Market Price", value: 1 },
  { label: "Contract Price", value: 2 },
  { label: "Market Price and Contract Price", value: 3 },
  { label: "No Price Comparison", value: 4 },
]

export default function UploadCommodity({ surveyTypeId, surveyId, onSave }: Props) {
  const { showSnackBar, showAlert, hideAlert } = useCommon()
  const [file, setFile] = useState<File | undefined>(undefined)
  const [saveRpmeBasket, { isLoading }] = useSaveRpmeBasketRPMEMutation()
  const [deleteSurvey] = useDeleteSurveyRPMEMutation()

  const [error, setError] = useState(false)
  const [priceCompare, setPriceCompare] = useState({ label: "", value: 0 })

  const handleSave = async () => {
    const errorMsg = "\nUpload a new file or abort the process."

    if (file && surveyTypeId && priceCompare?.value) {
      setError(false)
      const formData = new FormData()
      formData.append("file", file)

      try {
        const response = await saveRpmeBasket({ file: formData, surveyId, priceCompare: priceCompare.value }).unwrap()
        if (response?.resultCode === 0) {
          setError(true)
          showAlert(`${response?.resultMessage} ${errorMsg}`, "error")
          return
        }

        showSnackBar("Commodity Basket saved successfully!")
        if (onSave) {
          onSave()
        }
      } catch (errorSave: any) {
        setError(true)
        showAlert(
          (errorSave?.data?.title ||
            errorSave?.data ||
            "An error occured while saving the basket, please try again with valid file.") + errorMsg,
          "error",
        )
      }
    }
  }

  const handleAbort = () => {
    hideAlert()
    deleteSurvey(surveyId)
    if (onSave) onSave()
  }

  useEffect(() => {
    return () => {
      hideAlert()
    }
  }, [])

  return (
    <div className="max-w-4xl relative">
      <div className="space-y-6">
        {!isLoading && (
          <ExcelUploader
            onSelect={fileUpload => {
              setFile(fileUpload)
              if (fileUpload) {
                hideAlert()
                setError(false)
              }
            }}
            placeholder="Select the CSV containing the commodity basket"
          />
        )}

        <div className="flex w-96">
          <Select
            className="wfp--react-select-container"
            classNamePrefix="wfp--react-select"
            options={priceOptions}
            onChange={setPriceCompare as any}
          />
        </div>
      </div>

      {isLoading && <Loading active={isLoading} withOverlay={false} />}

      <div className="mt-12">
        {error && <AlertComponent />}
        {error && <Button action={handleAbort} label="Abort the process" className="btn-full blue" />}
        {!isLoading && !error && (
          <Button action={handleSave} label="Save" className={`btn-full blue ${priceCompare?.value || "disabled"}`} />
        )}
      </div>
    </div>
  )
}
